// ==================== 复制文本到剪贴板 ====================
// 优先使用 Clipboard API（需 https / localhost 安全上下文）；
// 不可用时回退到隐藏 textarea + execCommand（兼容 http 环境与旧浏览器），
// 保证聊天页「复制」、内置浏览器「复制链接」等功能在各类环境下都可用。

const fallbackCopy = (value) => {
  try {
    const input = document.createElement('textarea')
    input.value = value
    input.setAttribute('readonly', 'readonly')
    input.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;'
    document.body.appendChild(input)
    input.select()
    input.setSelectionRange(0, value.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(input)
    return ok
  } catch (e) {
    return false
  }
}

// 复制文本，返回 Promise<boolean>
export const copyText = (text) => {
  const value = String(text === null || text === undefined ? '' : text)
  if (!value) return Promise.resolve(false)
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(value)
      .then(() => true)
      .catch(() => fallbackCopy(value))
  }
  return Promise.resolve(fallbackCopy(value))
}
